/**
 * Created by meirr on 9/8/16.
 */
define(function (require) {

    var _ = require('underscore');
    var FilterItemTextInputViewController = require('web-agent-components/FilterItemTextInputViewController');
    var FilterItemMultiSelectionDropdownViewController = require('web-agent-components/FilterItemMultiSelectionDropdownViewController');
    var FilterItemTimeFrameViewController = require('web-agent-components/FilterItemTimeFrameViewController');
    var FilterItemNumericRangeViewController = require('web-agent-components/FilterItemNumericRangeViewController');
    var FilterItemMcsViewController = require('web-agent-components/FilterItemMcsViewController');
    var FilterItemCheckBoxSelectViewController = require('web-agent-components/FilterItemCheckBoxSelectViewController');
    var FilterItemMultiSelectionDropdownWithSearchViewController = require('web-agent-components/FilterItemMultiSelectionDropdownWithSearchViewController');
    var FilterItemDurationViewController = require('web-agent-components/FilterItemDurationViewController');
    // var FilterItemCheckBoxMoreOptionsWhenChecked = require('web-agent-components/FilterItemCheckBoxMoreOptionsWhenChecked');
    var FilterItemSurveyNameIdViewController = require('web-agent-components/FilterItemSurveyNameIdViewController');
    var FilterItemYesNoCheckBoxSelectViewController = require('web-agent-components/FilterItemYesNoCheckBoxSelectViewController');
    var FilterItemMultiTextInputViewController = require('web-agent-components/FilterItemMultiTextInputViewController');
    var FilterItemDropdownNumericRangeViewController = require('web-agent-components/FilterItemDropdownNumericRangeViewController');
    var FilterItemCollapsibleViewController = require('web-agent-components/FilterItemCollapsibleViewController');

    function getFilterItem(type, config, context) {
        switch(type) {
            case "textBoxInput":
                return new FilterItemTextInputViewController(config);
            case "multiSelect":
                _.assign(config, context);
                return new FilterItemMultiSelectionDropdownViewController(config);
            case "timeFrame":
                return new FilterItemTimeFrameViewController(config);
            case "numericRange":
                return new FilterItemNumericRangeViewController(config);
            case "mcs":
                return new FilterItemMcsViewController(config);
            case "singleCheckBox":
                return new FilterItemCheckBoxSelectViewController(config);
            case "multiSelectWithSearch":
                _.assign(config, context);
                return new FilterItemMultiSelectionDropdownWithSearchViewController(config);
            case "slaDuration":
                return new FilterItemDurationViewController(config);
            // case ("checkBoxMoreOptionsWhenChecked"):
            //     return new FilterItemCheckBoxMoreOptionsWhenChecked(config);
            case "surveyNameId":
                return new FilterItemSurveyNameIdViewController(config);
            case "yesNoCheckBox":
                return new FilterItemYesNoCheckBoxSelectViewController(config);
            case "multiText":
                return new FilterItemMultiTextInputViewController(config);
            case "dropdownNumericRange":
                return new FilterItemDropdownNumericRangeViewController(config);
            case "collapsible":
                return new FilterItemCollapsibleViewController(config);
        }

    }

    return {
        getFilterItem: getFilterItem
    };

});
